module.exports = __webpack_public_path__ + "static/media/14.b1367783.JPG";